import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api, { unwrap } from '../utils/api';

export default function EditCategory() {
  const { id } = useParams();
  const nav = useNavigate();
  const [form, setForm] = useState(null);

  useEffect(() => {
    api.get(`/categories/Category/${id}`).then(r => setForm(unwrap(r)));
  }, [id]);

  if (!form) return <p>Loading…</p>;
  const u = (k, v) => setForm(f => ({ ...f, [k]: v }));

  async function save() {
    await api.post('/categories/UpdateCategory', form);
    nav('/pages/categories');
  }

  return (
    <>
      <h1>Edit Category</h1>
      <div className="card" style={{ maxWidth: 640 }}>
        <div className="prop"><label>Name</label><input value={form.name || ''} onChange={e => u('name', e.target.value)} /></div>
        <div className="prop"><label>Slug</label><input value={form.friendlyUrlName || ''} onChange={e => u('friendlyUrlName', e.target.value)} /></div>
        <div className="row">
          <div className="prop" style={{ flex: 1 }}><label>Color</label><input type="color" value={form.color || '#af40f7'} onChange={e => u('color', e.target.value)} /></div>
          <div className="prop" style={{ flex: 1 }}><label>Background</label><input type="color" value={form.backgroundColor || '#f9f5ff'} onChange={e => u('backgroundColor', e.target.value)} /></div>
        </div>
        <div className="prop"><label>Order index</label><input type="number" value={form.orderIndex || 0} onChange={e => u('orderIndex', Number(e.target.value))} /></div>
        <button className="btn" onClick={save}>Save</button>
      </div>
    </>
  );
}
